import { render, staticRenderFns } from "./TemplateLibrary-v3-p2.vue?vue&type=template&id=2effd6d6&scoped=true&"
import script from "./TemplateLibrary-v3-p2.vue?vue&type=script&lang=js&"
export * from "./TemplateLibrary-v3-p2.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLibrary-v3-p2.vue?vue&type=style&index=0&id=2effd6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effd6d6",
  null
  
)

export default component.exports